const imageData = [
    {
        width: 420,
        type: "image/webp",
        mediaSize: "(max-width: 480px)",
        multiplier: 0.5,
        device: "mobile",
    },
    {
        width: 420,
        type: "image/jpeg",
        mediaSize: "(max-width: 480px)",
        multiplier: 0.5,
        device: "mobile",
    },
    {
        width: 720,
        type: "image/webp",
        mediaSize: "(max-width: 768px)",
        multiplier: 0.8,
        device: "tablet",
    },
    {
        width: 720,
        type: "image/jpeg",
        mediaSize: "(max-width: 768px)",
        multiplier: 0.8,
        device: "tablet",
    },
    {
        width: 1200,
        type: "image/webp",
        mediaSize: "(min-width: 769px)",
        multiplier: 1,
        device: "desktop",
    },
    {
        width: 1200,
        type: "image/jpeg",
        mediaSize: "(min-width: 769px)",
        multiplier: 1,
        device: "desktop",
    },
];

export default imageData;
